import { SvgIcon } from "@material-ui/core";

export const HouseCleanupIcon = ({
  className,
  fontSize = 80,
}: {
  className?: string;
  fontSize?: number;
}) => {
  return (
    <SvgIcon
      className={className}
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      style={{ fontSize, fill: "none" }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.2369 7.82504C33.3784 7.81452 33.5195 7.80957 33.6601 7.80957C33.8724 7.80957 34.0685 7.87903 34.2268 7.99646C34.7928 8.1546 35.36 8.42377 35.9207 8.8435L65.3348 30.428C65.7589 30.7392 65.8504 31.3352 65.5392 31.7593C65.228 32.1833 64.632 32.2748 64.2079 31.9636L57.2581 26.8638V65.2699C57.2581 68.1239 54.927 70.4551 52.073 70.4551H14.401C11.5469 70.4551 9.21577 68.1239 9.21577 65.2699V26.8637L2.26589 31.9636C1.84183 32.2748 1.2458 32.1833 0.934616 31.7593C0.623435 31.3352 0.714942 30.7392 1.139 30.428L30.5532 8.84349C31.1138 8.42377 31.6811 8.1546 32.247 7.99646C32.4053 7.87903 32.6014 7.80957 32.8137 7.80957C32.9543 7.80957 33.0954 7.81452 33.2369 7.82504ZM33.2369 9.73782C32.7198 9.7977 32.2127 9.97975 31.6919 10.3704L31.6839 10.3764L11.1205 25.466V65.2699C11.1205 67.0719 12.5989 68.5503 14.401 68.5503H52.073C53.875 68.5503 55.3534 67.0719 55.3534 65.2699V25.4661L34.7819 10.3705C34.261 9.97979 33.754 9.7977 33.2369 9.73782Z"
        fill="#F0CBA7"
      />
      <path
        d="M33.2369 9.73782C32.7198 9.7977 32.2127 9.97975 31.6919 10.3704L31.6839 10.3764L11.1205 25.466V65.2699C11.1205 67.0719 12.5989 68.5503 14.401 68.5503H52.073C53.875 68.5503 55.3534 67.0719 55.3534 65.2699V25.4661L34.7819 10.3705C34.261 9.97979 33.754 9.7977 33.2369 9.73782Z"
        fill="#F0CBA7"
      />
      <path
        d="M24.2421 64.7406H13.4484C11.1203 64.7406 9.21558 62.8358 9.21558 60.5078V20.5078"
        stroke="#EA7200"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M0.75 26.4339L30.168 4.84656C31.0145 4.21164 31.8611 4 32.7077 4"
        stroke="#EA7200"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M55.3533 20.5078V41.0369"
        stroke="#EA7200"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M31.8612 4C32.7078 4 33.5543 4.21164 34.4009 4.84656L63.8189 26.4339"
        stroke="#EA7200"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <g clipPath="url(#clip0_6802_9985)">
        <path
          d="M71.8326 44.3701H62.9151V52.0801C62.9151 49.1852 60.9512 46.8431 58.5218 46.8431H54.1286H35.45C34.2134 46.8431 33.0206 47.4978 32.2205 48.6325L27.609 55.1351V65.7691C27.609 68.664 29.5729 71.0061 32.0023 71.0061H34.1989H34.3007C34.7517 73.5809 36.9774 75.5303 39.6977 75.5303C42.4181 75.5303 44.6438 73.5955 45.0948 71.0061H45.313H58.6237H58.7255C59.1765 73.5809 61.4022 75.5303 64.1225 75.5303C66.8428 75.5303 69.0686 73.5955 69.5195 71.0061H78.1751C79.5135 71.0061 80.7354 69.9005 80.7354 68.4458V53.2876C80.75 48.3997 76.8368 44.3701 71.8326 44.3701Z"
          fill="#F0CBA7"
        />
        <path
          d="M55.0451 44.6177H43.291C42.84 44.6177 42.4618 44.2831 42.389 43.8467L42.0981 41.941C42.069 41.7374 42.1126 41.5192 42.2145 41.3446L45.4439 35.7585C45.6912 35.3221 46.244 35.1766 46.6805 35.4239L56.6744 41.1555C56.8926 41.2864 57.0526 41.5046 57.1108 41.7519C57.169 41.9992 57.1108 42.2611 56.9508 42.4793L56.0489 43.7158C56.0198 43.8904 55.9325 44.0504 55.8161 44.1668C55.6561 44.4432 55.3651 44.6177 55.0451 44.6177ZM44.0765 42.7993H54.4778L54.8996 42.232L46.5786 37.4605L43.9601 41.9847L44.0765 42.7993Z"
          fill="#226937"
        />
        <path
          d="M42.9999 41.7952L42.1126 36.2236L29.922 37.9838L30.6639 43.7009H41.9671L42.9999 41.7952Z"
          fill="#F0CBA7"
        />
        <path
          d="M41.9671 44.6175H30.6639C30.1984 44.6175 29.8202 44.2829 29.762 43.8174L29.0346 38.0858C28.9765 37.5912 29.311 37.1402 29.8056 37.0675L41.9962 35.3073C42.4763 35.2346 42.9418 35.5691 43.0291 36.0637L43.9164 41.6499C43.9455 41.8535 43.9164 42.0427 43.8146 42.2172L42.7818 44.1229C42.6072 44.4284 42.3017 44.6175 41.9671 44.6175ZM31.464 42.7991H41.4289L42.0544 41.6353L41.3561 37.2421L30.9403 38.755L31.464 42.7991Z"
          fill="#226937"
        />
        <path
          d="M31.304 68.7806H29.1073C26.1834 68.7806 23.7976 66.0167 23.7976 62.6272V51.9932C23.7976 51.804 23.8558 51.6149 23.9722 51.4695L28.5836 44.9669C29.5583 43.5849 31.013 42.7993 32.555 42.7993H55.6269C58.5509 42.7993 60.9367 45.5633 60.9367 48.9528V60.0087C60.9367 60.5178 60.5293 60.9106 60.0347 60.9106C59.5401 60.9106 59.1328 60.5033 59.1328 60.0087V48.9528C59.1328 46.567 57.5617 44.6177 55.6415 44.6177H32.5405C31.5949 44.6177 30.693 45.1269 30.0529 46.0143L25.616 52.2841V62.6272C25.616 65.0129 27.1871 66.9622 29.1073 66.9622H31.304C31.7986 66.9622 32.2059 67.3696 32.2059 67.8642C32.2059 68.3588 31.7986 68.7806 31.304 68.7806Z"
          fill="#EA7200"
        />
        <path
          d="M75.2803 68.7805H66.6101C66.1155 68.7805 65.7082 68.3732 65.7082 67.8786C65.7082 67.384 66.1155 66.9767 66.6101 66.9767H75.2803C76.0804 66.9767 76.9386 66.3075 76.9386 65.3183V54.2188H60.0057C59.5111 54.2188 59.1038 53.8114 59.1038 53.3168V41.2426C59.1038 40.7335 59.5111 40.3262 60.0057 40.3262H68.9231C74.3347 40.3262 78.7425 44.734 78.7425 50.1455V65.2892C78.7571 67.224 77.2005 68.7805 75.2803 68.7805ZM60.9222 52.3858H76.9386V50.1455C76.9386 45.7232 73.3455 42.1446 68.9377 42.1446H60.9367V52.3858H60.9222Z"
          fill="#EA7200"
        />
        <path
          d="M61.2276 73.3045C57.6926 73.3045 54.8268 70.4241 54.8268 66.9037C54.8268 63.3833 57.7071 60.5029 61.2276 60.5029C64.7625 60.5029 67.6283 63.3833 67.6283 66.9037C67.6283 70.4241 64.7625 73.3045 61.2276 73.3045ZM61.2276 62.3068C58.6527 62.3068 56.6452 64.3288 56.6452 66.8892C56.6452 69.4495 58.6527 71.4715 61.2276 71.4715C63.8024 71.4715 65.8099 69.4495 65.8099 66.8892C65.8099 64.3288 63.8024 62.3068 61.2276 62.3068Z"
          fill="#EA7200"
        />
        <path
          d="M36.8029 73.3045C33.2679 73.3045 30.4021 70.4241 30.4021 66.9037C30.4021 63.3833 33.2824 60.5029 36.8029 60.5029C40.3378 60.5029 43.2037 63.3833 43.2037 66.9037C43.2037 70.4241 40.3378 73.3045 36.8029 73.3045ZM36.8029 62.3068C34.228 62.3068 32.2205 64.3288 32.2205 66.8892C32.2205 69.4495 34.228 71.4715 36.8029 71.4715C39.3777 71.4715 41.3853 69.4495 41.3853 66.8892C41.3853 64.3288 39.3777 62.3068 36.8029 62.3068Z"
          fill="#EA7200"
        />
        <path
          d="M55.7287 68.7804H42.418C41.9234 68.7804 41.5161 68.3731 41.5161 67.8785C41.5161 67.3839 41.9234 66.9766 42.418 66.9766H55.7287C56.2234 66.9766 56.6307 67.3839 56.6307 67.8785C56.6307 68.3731 56.2379 68.7804 55.7287 68.7804Z"
          fill="#EA7200"
        />
        <path
          d="M52.5139 57.768C52.0193 57.768 51.6119 57.3607 51.6119 56.8661V49.1851C51.6119 48.676 52.0193 48.2832 52.5139 48.2832C53.0085 48.2832 53.4158 48.6905 53.4158 49.1851V56.8661C53.4303 57.3607 53.023 57.768 52.5139 57.768Z"
          fill="#226937"
        />
        <path
          d="M44.4837 57.768C43.9891 57.768 43.5818 57.3607 43.5818 56.8661V49.1851C43.5818 48.676 43.9891 48.2832 44.4837 48.2832C44.9783 48.2832 45.3856 48.6905 45.3856 49.1851V56.8661C45.4002 57.3607 44.9929 57.768 44.4837 57.768Z"
          fill="#226937"
        />
        <path
          d="M36.4682 57.768C35.9736 57.768 35.5663 57.3607 35.5663 56.8661V49.1851C35.5663 48.676 35.9736 48.2832 36.4682 48.2832C36.9628 48.2832 37.3701 48.6905 37.3701 49.1851V56.8661C37.3701 57.3607 36.9628 57.768 36.4682 57.768Z"
          fill="#226937"
        />
      </g>
      <defs>
        <clipPath id="clip0_6802_9985">
          <rect
            width="56.9524"
            height="40.2085"
            fill="white"
            transform="translate(23.7976 35.3071)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
